/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdSideBarItemProps } from './type';
const props: TdSideBarItemProps = {
  /** 透传至 Badge 组件 */
  badgeProps: {
    type: Object,
  },
  /** 是否禁用 */
  disabled: {
    type: Boolean,
    value: false,
  },
  /** 图标，传对象则透传至 Icon */
  icon: {
    type: null,
  },
  /** 展示的标签 */
  label: {
    type: String,
    value: '',
  },
  /** 当前选项的值 */
  value: {
    type: null,
  },
};

export default props;
